import React, { useEffect } from "react";
import TopBar from "../TopBar/TopBar";
import Tabs from "../Tabs/Tabs";
import { tabs } from "./layout";
import useCheersStore from "../../../../common/hooks/useCheersStore";
import style from "./Base.module.scss";
import useTwitchContext from "../../../../common/hooks/useTwitchContext";
import BitsDisabled from "./bitsDisabled/BitsDisabled";
import GA from "../../../../common/services/GA";

const Base: React.FC = () => {
  const cheersStore = useCheersStore();
  const { auth, isBitsEnabled, isVisible, channel } = useTwitchContext();

  useEffect(() => {
    cheersStore.getProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!channel) {
      return;
    }

    GA.sendEvent("broadcaster", "loaded_id", channel.broadcaster_id);
    GA.sendEvent("broadcaster", "loaded_name", channel.broadcaster_name);
    GA.sendEvent("broadcaster", "loaded_bits_support_on", isBitsEnabled ? "true" : "false");
    GA.setPage(channel.broadcaster_name);
  }, [channel, isBitsEnabled]);

  useEffect(() => {
    GA.sendEvent("visibility", isVisible ? "open_extension" : "close_extension");
  }, [isVisible]);

  useEffect(() => {
    cheersStore.setChannelId(auth.channelId);
    cheersStore.getEmotes();
  }, [auth.channelId, cheersStore]);

  const renderView = (): React.ReactNode => {
    if (isBitsEnabled) {
      return (
        <>
          <TopBar />
          <div className={style.base__tabs}>
            <Tabs data={tabs} />
          </div>
        </>
      );
    }
    return <BitsDisabled />;
  };

  return <div className={style.base}>{renderView()}</div>;
};

export default Base;
